<template>
  <v-dialog v-model="dialogIsOpen" width="1200px" persistent>
    <v-card>
      <v-card-title>
        <span class="table-card-title">Selecionar oferta</span>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col class="px-6 py-2">
            <mf-search v-model.lazy="delaySearch" placeholder="Buscar oferta" hide-details />
          </v-col>
        </v-row>
        <v-row v-show="existSelectedOfferSchedule" no-gutters>
          <v-col class="px-6">
            <v-chip-group show-arrows active-class="primary--text">
              <v-chip small>
                <b>{{ selectedOfferSchedule.name }}</b>
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>
        <mf-tabs-menu v-if="useErpSalesAsOffersSchedules" v-model="templateTab" :tabs="tabsMenuItems" class="my-4" />
        <v-data-table
          :headers="headers"
          :loading="$apollo.queries.offerSchedules.loading"
          :options.sync="options"
          :items="offerSchedules.offerSchedules"
          single-select
          :server-items-length="offerSchedules.records"
          hide-details
          item-key="_id"
          :footer-props="{ itemsPerPageOptions: [5, 10, 15] }"
          fixed-header
          :height="tableHeight"
        >
          <template v-slot:item="{ item }">
            <tr :key="item._id" class="cursor-pointer" @click="selectOfferSchedule(item)">
              <td>
                <v-radio-group :disabled="disableOfferType(item.types)" :value="selectedOfferSchedule._id" @change="selectOfferSchedule(item)">
                  <v-radio color="primary" :value="item._id" />
                </v-radio-group>
              </td>
              <td>
                <mf-icon fill small :color="getStatusLabel(item.status).color">fiber_manual_record</mf-icon>
                {{ getStatusLabel(item.status).text }}
              </td>
              <td class="nowrap-row" style="max-width: 300px">
                <v-tooltip top max-width="250" content-class="truncated-tooltip">
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ item.name | truncate({ length: 70 }) }}</span>
                  </template>
                  <span>{{ item.name }}</span>
                </v-tooltip>
              </td>
              <td class="nowrap-row" style="max-width: 300px">
                <v-tooltip top max-width="250" content-class="truncated-tooltip">
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ item.description | truncate({ length: 150 }) }}</span>
                  </template>
                  <span>{{ item.description }}</span>
                </v-tooltip>
              </td>
              <td>{{ item.products_count }}</td>
              <td>{{ item.personalized ? 'Personalizada' : 'Geral' }}</td>
              <td class="nowrap-row">
                <v-tooltip v-if="item.types.length > 1" right>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" style="cursor: auto" v-on="on">Múltiplos</span>
                  </template>
                  <span v-for="(type, index) in item.types" :key="index" style="display: block">
                    {{ formatAndGetOfferTypeLabel(type) }}
                  </span>
                </v-tooltip>
                <span v-else-if="item.types.length === 1">
                  {{ formatAndGetOfferTypeLabel(item.types[0]) }}
                </span>
                <span v-else> - </span>
              </td>
              <td class="nowrap-row">
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" style="cursor: auto" v-on="on">
                      {{ getUnits(item, true) }}
                    </span>
                  </template>
                  <span v-for="(unit, index) in item.units" :key="index" style="display: block">
                    {{ unit.name }}
                  </span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <mf-action-buttons
        class="pa-2"
        :primary-button="{
          text: 'Selecionar',
          action: linkOfferScheduleToCampaignAndCloseModal,
          isVisible: true,
          isDisabled: !existSelectedOfferSchedule,
        }"
        :extra-button="{
          text: 'Cancelar',
          action: closeDialog,
          isVisible: true,
        }"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { QUERY_LIST_SALES_CAMPAIGNS } from '@/modules/campanhas/gestao-ofertas-v2/graphql'
import { getUnits, getStatusLabel } from '@/config/helpers.js'
import { getProductFormatTypeLabel } from '@/modules/mobile/ofertas/helpers/productType.js'
export default {
  name: 'OfferScheduleModal',
  inject: ['linkOfferScheduleToCampaign'],
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    linkedOfferSchedule: {
      type: Object,
      default: () => ({}),
    },
    blockOffersTypes: {
      type: Array,
      default: () => [],
    },
    hidePersonalized: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    options: {},
    selectedOfferSchedule: {},
    offerSchedules: [],
    search: '',
    delaySearch: '',
    timeout: null,
    templateTab: 0,
  }),
  computed: {
    dialogIsOpen: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
    tabsMenuItems() {
      return [
        {
          name: 'Ofertas da plataforma',
        },
        {
          name: 'Ofertas do ERP',
        },
      ]
    },
    headers() {
      return [
        {
          value: '',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          width: '14%',
        },
        {
          text: 'Nome',
          value: 'name',
          width: '12%',
        },
        {
          text: 'Descrição',
          value: 'description',
          width: '15%',
        },
        {
          text: 'Produtos',
          value: 'products_count',
          width: '13%',
        },
        {
          text: 'Tipo',
          value: 'is_personalized',
          width: '7%',
          sortable: false,
        },
        {
          text: 'Formato',
          value: 'types',
          width: '15%',
        },
        {
          text: 'Lojas',
          value: 'units',
          width: '24%',
        },
      ]
    },
    existSelectedOfferSchedule() {
      return Object.entries(this.selectedOfferSchedule).length
    },
    useErpSalesAsOffersSchedules() {
      return this.$getAllowedModules()['use_erp_sales_as_offers_schedules']
    },
    tableHeight() {
      const itemCount = this.offerSchedules?.offerSchedules?.length || 0

      if (itemCount === 0) return 'auto'
      if (itemCount === 1) return 'auto'
      if (itemCount <= 3) return 'auto'

      return '400'
    },
  },
  apollo: {
    offerSchedules: {
      query: QUERY_LIST_SALES_CAMPAIGNS,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
      variables() {
        const sortDirection = this.options.sortDesc ? this.options.sortDesc.map((direction) => (direction ? 'DESC' : 'ASC')) : []
        const variables = {
          page: this.options.page || 1,
          pageSize: this.options.itemsPerPage || 10,
          search: this.search,
          sort: this.options.sortBy,
          sortDirection,
          status: ['active', 'scheduled'],
          includeAuto: false,
        }
        if (this.hidePersonalized) {
          variables.personalized = false
        }
        if (this.useErpSalesAsOffersSchedules && this.templateTab === 1) {
          variables.includeAuto = true
        }
        return variables
      },
      context() {
        return {
          uri: this.$microservicesUrls['sales'],
        }
      },
      skip() {
        if (!this.dialogIsOpen) return true
        return false
      },
    },
  },
  watch: {
    delaySearch(value) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.search = value
        this.options.page = 1
      }, 500)
    },
    offerSchedules(value) {
      if (this.linkedOfferSchedule?._id) {
        this.selectOfferSchedule(this.linkedOfferSchedule)
      } else if (value?.offerSchedules?.length) {
        this.selectOfferSchedule(value.offerSchedules[0])
      }
    },
  },
  methods: {
    getStatusLabel,
    getUnits,
    disableOfferType(types) {
      if (this.blockOffersTypes.length === 0) return false
      const isDisabled = types.some((type) => this.blockOffersTypes.includes(type.trim()))
      return isDisabled
    },
    closeDialog() {
      this.options.page = 1
      this.offerSchedules = {}
      this.dialogIsOpen = false
      this.selectedOfferSchedule = {}
      this.search = ''
      this.delaySearch = ''
      this.timeout = null
    },
    selectOfferSchedule(offerSchedule) {
      const { _id, name, types } = offerSchedule
      if (this.disableOfferType(types)) return

      this.selectedOfferSchedule = { _id, name }
    },
    linkOfferScheduleToCampaignAndCloseModal() {
      if (this.existSelectedOfferSchedule) {
        this.linkOfferScheduleToCampaign(this.selectedOfferSchedule._id)
        this.closeDialog()
      }
    },
    formatAndGetOfferTypeLabel(type) {
      return getProductFormatTypeLabel(type)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .v-input--is-disabled .v-input__control .v-input__slot {
  background-color: none !important;
}
</style>
